
import React from 'react';
import { Link } from 'react-router-dom';
import { Shield } from 'lucide-react';

const SignInHeader = () => {
  return (
    <div className="sm:mx-auto sm:w-full sm:max-w-md">
      <div className="flex justify-center">
        <Shield className="h-12 w-12 text-white" />
      </div>
      <h2 className="mt-6 text-center text-3xl font-bold text-white">
        Welcome to bluetooth$
      </h2>
      <p className="mt-2 text-center text-sm text-white/80">
        Send money anytime, anywhere right at your fingertips with AI security
      </p>
      <p className="mt-1 text-center text-xs text-white/60">
        Your card credentials stay only on your device
      </p>
      <p className="mt-4 text-center text-sm text-white/80">
        Sign in to your account or{' '}
        <Link 
          to="/signup" 
          className="font-medium text-white hover:text-blue-200 underline"
        >
          create a new account
        </Link>
      </p>
    </div>
  );
};

export default SignInHeader;
